import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  toggle() {
    const isOpen = !this.menuTarget.classList.contains("hidden")

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.iconTarget.setAttribute("d", "M6 18L18 6M6 6l12 12")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.iconTarget.setAttribute("d", "M4 6h16M4 12h16M4 18h16")
    document.body.style.overflow = ""
  }

  closeOnNav() {
    if (!this.menuTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
